import React, { useState } from "react";
import listings from "../data/listings";

const ITEMS_PER_PAGE = 6;

const AllListings = () => {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(listings.length / ITEMS_PER_PAGE);

  const start = (page - 1) * ITEMS_PER_PAGE;
  const end = start + ITEMS_PER_PAGE;
  const currentListings = listings.slice(start, end);

  return (
    <section className="py-20 bg-white w-full px-6 md:px-20">
      {/* Parallax Image Section */}
      <div className="relative h-64 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://cdn.pixabay.com/photo/2017/07/17/00/54/house-2511060_640.jpg')`,
            height: "100vh", // Set to full viewport height
            width: "100%", // Ensure it takes full width
            top: 0,
            left: 0,
            transform: "translateZ(0)",
            willChange: "transform",
          }}
        />
        <div className="relative z-10 flex flex-col items-center justify-center h-full bg-black bg-opacity-50">
          <h2 className="text-3xl font-bold text-white mb-2">Properties</h2>
          <h2 className="text-1xl font-bold text-yellow-500">
            Find your dream homes with me.
          </h2>
        </div>
      </div>

      {/* Listings Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
        {currentListings.map((listing, i) => (
          <div
            key={i}
            className="bg-gray-100 rounded shadow overflow-hidden hover:shadow-lg transition"
          >
            <img
              src={listing.image}
              alt={listing.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="text-xl font-semibold mb-1">{listing.title}</h3>
              <p className="text-gray-600 text-sm mb-1">{listing.location}</p>
              <p className="text-blue-900 font-bold">${listing.price}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-10 space-x-2">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
        >
          Prev
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => setPage(i + 1)}
            className={`px-4 py-2 rounded ${
              page === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-100 hover:bg-gray-200"
            }`}
          >
            {i + 1}
          </button>
        ))}
        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </section>
  );
};

export default AllListings;
